import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useState, useEffect } from "react";

export default function PopupNewsletter({ isOpen, setIsOpen }) {
  const [formData, setFormData] = useState({ nombre: '', email: '' });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setSuccess(true);
        setError(null);
        setFormData({ nombre: '', email: '' });
      } else {
        const data = await res.json();
        setError(data.message || 'Error al suscribirse');
      }
    } catch (err) {
      setError('Error de conexión');
    }
  };

  useEffect(() => {
    let timer;
    if (success || error) {
      timer = setTimeout(() => {
        setSuccess(false);
        setError(null);
      }, 2400);
    }

    return () => clearTimeout(timer);
  }, [success, error]);


  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-eryndra-ivory border border-eryndra-gold shadow-xl rounded-xl p-8 w-full max-w-md relative"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 text-eryndra-burgundy hover:text-red-600"
            >
              <X size={24} />
            </button>

            <h2 className="text-3xl font-cinzel text-eryndra-forest font-bold mb-2 text-center">
              ¡Únete a nuestra Newsletter!
            </h2>
            <p className="text-eryndra-forest font-bellefair text-xl mb-6 text-center">
              Entérate de nuestros eventos literarios, bailes de fantasía y lanzamientos mágicos.
            </p>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <input
                type="text"
                name="nombre"
                placeholder="Tu nombre"
                value={formData.nombre}
                onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}

                required
                className="w-full px-4 py-2 border rounded-lg border-eryndra-gold focus:outline-none focus:ring-2 focus:ring-eryndra-gold"
              />
              <input
                type="email"
                name="email"
                placeholder="Tu correo electrónico"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="w-full px-4 py-2 border rounded-lg border-eryndra-gold focus:outline-none focus:ring-2 focus:ring-eryndra-gold"
              />

              <button
                type="submit"
                className="w-full bg-eryndra-burgundy text-eryndra-cream font-bold py-2 px-4 rounded-lg hover:bg-eryndra-gold hover:text-eryndra-burgundy transition"
              >
                Suscribirme
              </button>

              <AnimatePresence mode="wait">
              <div className="mt-4">
                {success && (
                  <motion.p
                    key="success"
                    className="text-green-600"
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.4 }}
                  >
                    ¡Gracias por suscribirte!
                  </motion.p>
                )}
                {error && (
                  <motion.p
                    key="error"
                    className="text-red-600"
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.4 }}
                  >
                    {error}
                  </motion.p>
                )}
                </div>
              </AnimatePresence>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
